import { useState } from "react";

const faqs = [
  {
    q: "这份名单里的人物与事件如何整理出来的？",
    a: "本页以公开讨论中的聊天记录、直播录屏、图片对比等素材为线索，按「人物 → 争议点 → 事件时间线」归档汇总。每条关键素材均标注分区与时间，供你自行跳转核对原始来源，避免只凭单一截图下结论。",
  },
  {
    q: "为什么有些条目标注了「存疑 / 待验证」？",
    a: "吃瓜讲究实锤也讲究严谨。来源不全、时间戳对不上或仅有单一视角的条目，会统一折叠并标注「存疑」，等你补全素材后我们才会将它归类到实锤分区。别让剪辑和断章取义带偏你。",
  },
  {
    q: "证据类型都有哪些？我只想看录屏怎么办？",
    a: "素材按类型分了四个入口条：主播塌房实锤（聊天记录与脚本）、网红翻车名单（滤镜与人设对比）、直播丑闻录屏（事故现场切片）、人物档案专区（按人物梳理往事）。只想看图或视频，直接进对应入口即可。",
  },
  {
    q: "多久更新一次？怎样不错过新瓜？",
    a: "事件进展会同步到人物时间线，热度榜每 6 小时刷新。在「追更这期事件」里勾选关注的分区并开启提醒，下次更新就会集中提示你，别再摸黑吃剩饭。",
  },
  {
    q: "为什么给每个账号单独建「档案」？",
    a: "同一个主播可能同时踩多条线，分散在各分区容易看漏。按人物建档能把他的争议点、实锤条数与时间线合并到一处，翻车往事一次看全，逻辑更清楚。",
  },
];

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="max-w-[1400px] mx-auto px-3 md:px-6 pt-10 md:pt-14 scroll-mt-20">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
        <div className="lg:col-span-1">
          <span className="inline-flex items-center gap-1 rounded bg-secondary-100 text-secondary-900 px-2 py-0.5 text-[11px] whitespace-nowrap">
            <i className="ri-question-line w-3.5 h-3.5 flex items-center justify-center"></i>
            使用指南
          </span>
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mt-2">这份名单怎么用？</h2>
          <p className="text-[13px] md:text-sm text-foreground-600 mt-2 leading-relaxed">
            吃瓜不是转图就完事。先看分区入口 → 再进人物档案看全貌 → 最后到时间线与切片自行核对，别让断章取义带偏你。
          </p>
          <a href="#figure" className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-foreground-300 text-foreground-700 hover:bg-background-100 px-4 py-2.5 text-sm transition-colors">
            从人物档案开始<i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>

        <div className="lg:col-span-2 flex flex-col gap-2.5">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div key={f.q} className={`rounded-lg border bg-background-100 transition-colors ${open ? "border-accent-300" : "border-background-200"}`}>
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : i)}
                  className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left"
                >
                  <span className={`text-[14px] font-medium ${open ? "text-accent-900" : "text-foreground-900"}`}>{f.q}</span>
                  <i className={`${open ? "ri-subtract-fill" : "ri-add-fill"} w-5 h-5 flex items-center justify-center shrink-0 text-foreground-500 transition-transform`}></i>
                </button>
                {open && <p className="px-4 pb-4 text-[13px] text-foreground-600 leading-relaxed">{f.a}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}